<template>
    <div class="estate" v-if="data">
        <div class="row" v-if="data.items && data.items.length">
            <z-list>
                <z-list-item v-for="(item, index) in data.items"  :key="index">
                    <z-link :href="item.file.link" internal target="_blank" v-html="item.name"></z-link>
                </z-list-item>
            </z-list>
        </div>
    </div>
</template>

<script>
export default {
    name: 'estate',
    data () {
        console.log('estate',this.$root.app.components['estate']);
        return {
            data: this.$root.app.components['estate']
        }
    }
}
</script>
